module.exports = __webpack_public_path__ + "288800b2680d7569ca380e5bddaebd3c.md";